angular.module('gym.waivers').controller('WaiversOptInCtrl', ["$scope", "$rootScope", "$state", "$window", "Waivers", "GTMService", "FreeTrialRemindMessageText", function($scope, $rootScope, $state, $window, Waivers, GTMService, FreeTrialRemindMessageText) {
  var billingPageUrl;
  $scope.isFeatureEnabled = !!_.find($rootScope.gym.features_enabled, function(feature) {
    return feature === 'waivers';
  });
  $scope.optIn = function() {
    return Waivers.doPOST({}, 'opt_in').then(function() {
      var url;
      url = $state.href('gym.waivers.list');
      return $window.open(url, '_self');
    });
  };
  $scope.onViewPricingClick = function() {
    return GTMService.trackPage('Waivers', 'View Pricing Plans');
  };
  billingPageUrl = $state.href('gym.subscription.tab', {
    tab: 'subscriptions'
  });
  $scope.getRemindMessageText = FreeTrialRemindMessageText.get('Accelerating or Established', billingPageUrl);
  return $scope.isFreeTrialRemindMessageAvailable = $rootScope.gym.on_trial_period && $rootScope.gym.trialling_highest_plan;
}]);
